<template>
  <div class="preview__wrapper">
    <p>Preview</p>
    <div
      class="tag__preview"
      :style="{color, backgroundColor}"
    >
      <span class="label">{{ name }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TagPreview',
  props: [
    'color',
    'backgroundColor',
    'name',
  ],
};
</script>


<style scoped lang="scss">
.preview__wrapper {
  height: 100px;
}
.tag__preview {
  display: flex;
  justify-content: center;
  align-items: center;

  padding: 10px;
  border: 1px solid black;
  border-radius: 15px;
  min-width: 150px;
  width: fit-content;
  max-width: 300px;
  height: 50px;
  margin-left: auto;
  margin-right: auto;

  .label {
    max-width: 280px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}
</style>